// Design reminder: Industry pages remain in the current Vue routing model and share a single, theme-consistent view.
import { createRouter, createWebHistory } from 'vue-router'

// Auth guard function
const requireAuth = (to, from, next) => {
  const token = localStorage.getItem('token');
  if (!token) {
    next({ name: 'Login', query: { redirect: to.fullPath } });
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('@/views/ServicesView.vue')
  },
  {
    path: '/services/crm',
    name: 'CRM',
    component: () => import('@/views/services/CRMView.vue')
  },
  {
    path: '/services/field-service',
    name: 'FieldService',
    component: () => import('@/views/services/FieldServiceView.vue')
  },
  {
    path: '/services/mobile-integration',
    name: 'MobileIntegration',
    component: () => import('@/views/services/MobileIntegrationView.vue')
  },
  {
    path: '/services/server-migration',
    name: 'ServerMigration',
    component: () => import('@/views/services/ServerMigrationView.vue')
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('@/views/SolutionsOverviewView.vue')
  },
  {
    path: '/solutions/zynaccounting',
    name: 'ZynAccounting',
    component: () => import('@/views/SolutionsView.vue')
  },
  {
    path: '/solutions/zynagentics',
    name: 'ZynAgentics',
    component: () => import('@/views/ZynAgenticsView.vue')
  },
  {
    path: '/industries/:industry',
    name: 'Industry',
    component: () => import('@/views/IndustryView.vue')
  },
  {
    path: '/case-studies',
    name: 'CaseStudies',
    component: () => import('@/views/CaseStudiesView.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/views/BlogView.vue')
  },
  {
    path: '/blog/:slug',
    name: 'BlogPost',
    component: () => import('@/views/BlogPostView.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/ContactView.vue')
  },
  {
    path: '/admin/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/admin/blog',
    name: 'BlogManagement',
    component: () => import('@/views/BlogManagementView.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/admin/diagnostics',
    name: 'Diagnostics',
    component: () => import('@/views/DiagnosticsView.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/health-check',
    name: 'HealthCheck',
    component: () => import('@/views/HealthCheckView.vue')
  },
  // Add catch-all route to handle 404s
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/HomeView.vue') // Redirect to home or create a 404 page
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new route
    return { top: 0 }
  }
})

export default router
